<template>

    <div class="wrapper-main blue-background">

        <!--STATE loading: LOADER-->
        <div v-if="state === 'loading'" class="state-container">

            <LottieLoader :size="30"></LottieLoader>

        </div>

        <!--STATE 2: SUCCESS-->
        <div v-if="state === 'success'" class="state-container">

            <div class="flex-collumn">

                <img class="happy-earth" src="/img/earth/happy.svg">

                <h1 v-if="!name" class="title-success">{{ $t('magic_success_title_hello') }}</h1>
                <h1 v-else class="title-success">{{ $t('magic_success_title_hello_personal', 0, { first_name: name }) }}</h1>

                <div class="btn-mlp-success-container">

                    <button class="btn btn-big btn-green" @click="start">{{ $t('magic_success_cta') }}</button>

                </div>

            </div>

        </div>

        <!--STATE 1: ERROR-->
        <div v-if="state === 'error'" class="state-container">

            <div class="flex-collumn">

                <div class="white-bubble">!</div>

                <h1 class="title-error">{{ $t('magic_error_title') }}</h1>

                <p class="text-error">{{ $t('magic_error_subtitle') }}</p>

                <button class="btn btn-error-mlp" @click="restart">{{ $t('magic_error_cta') }}</button>

            </div>

        </div>

        <!--STATE 4: TIME OUT-->
        <div v-if="state === 'timeOut'" class="state-container">

            <div class="flex-collumn">

                <div class="white-bubble">!</div>

                <h1 class="title-error">{{ $t('magic_timeout_title') }}</h1>

                <p class="text-error">{{ $t('magic_timeout_subtitle') }}</p>

                <button class="btn btn-big btn-error-mlp" @click="sendBack">{{ $t('magic_timeout_cta') }}</button>

            </div>

        </div>

    </div>

</template>

<script>

    import Vuex from 'vuex'

    import Storage from '@/helpers/storage'

    import Auth from '@/modules/auth'
    import Tag from '@/modules/tag'
    import UserFlow from '@/modules/userFlow'

    import LottieLoader from '@/components/lottie/LottieLoader'

    export default {

        name: 'magic-link-post',

        components: { LottieLoader },

        watch: {

            state: function (state) {

                switch (state) {
                    case 'loading':
                        UserFlow.setPage(this, 'magic_loader')
                        break
                    case 'success':
                        UserFlow.setPage(this, 'magic_success')
                        break
                    case 'error':
                        UserFlow.setPage(this, 'magic_error')
                        break
                    case 'timeOut':
                        UserFlow.setPage(this, 'magic_timeout')
                        break
                }

            },

            code: function() {

                this.runRequest()

            }
        },

        data() {

            return {
                state: '',
                code: '',
                error: '',
                name: ''
            }

        },

        created() {

            // When user click on email, deconnect him before send request for magic link
            Storage.removeItem('token')

            this.state = 'loading'

            this.code = this.$route.query.code
            this.error = this.$route.query.error

            if (!this.code) {

                this.$router.push({ path: '/' })

            }



        },

        methods: {

            ...Vuex.mapActions(['setUser']),

            runRequest() {

                //if "getMagicUser" launch in mounted, "code" is sometimes empty
                if(this.$route.name === 'magic-link') {

                    this.getMagicUser()

                } else {

                    this.getAuthLink()

                }
            },

            getMagicUser () {

                Auth.getMagicLinkUser(this.code)
                    .then(data => {

                        this.successRequest(data)

                    })
                    .catch(error => {

                        this.errorRequest(error)

                    })

            },

            getAuthLink () {

                Auth.getAuthLink(this.code)
                    .then(data => {

                        this.successRequest(data)

                    })
                    .catch(error => {

                        this.errorRequest(error)

                    })

            },

            successRequest(data) {

                if (data && data.result && data.result.token) {

                    this.state = 'success'

                    this.setUser(data.result.user)

                    this.name = data.result.user.firstname

                    Storage.setItem('token', data.result.token)

                } else {

                    this.state = 'error'

                    Tag.pageViewAmplitude(this, 'magic_error')

                }

            },

            errorRequest(error) {

                if (error && error.message === 'timeout') {

                    this.state = 'timeOut'

                } else {

                    this.state = 'error'

                    Tag.pageViewAmplitude(this, 'magic_error')

                }

            },

            start () {

                this.$router.push({ path: '/fetch'})

            },

            restart () {

                this.state = 'loading'

                this.runRequest()

            },

            sendBack() {

                Tag.clickAmplitude(this, 'next')

                this.$router.push({ path: '/magic-request-email'})

            }

        }

    }
</script>

<style scoped lang="scss">

    .blue-background {
        background-color: $blue;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 16px;
    }

    .happy-earth {
        width: 128px;
        object-fit: contain;
    }

    .state-container {
        @media screen and (min-width: $above-tablet-length) {
            max-width: 501px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .title-success {
        font-size: 22px;
        font-weight: bold;
        line-height: 1.27;
        letter-spacing: -0.2px;
        text-align: center;
        color: $white;
        margin: 35px 0 0;
        @media screen and (min-width: $above-tablet-length) {
            font-size: 32px;
            line-height: 1.25;
            margin: 46px 0 160px;
        }
    }

    .btn-mlp-success-container {
        position: fixed;
        bottom: 32px;
        width: 100%;
        padding: 0 16px;
        @media screen and (min-width: $above-tablet-length) {
            position: static;
            padding: 0;
        }
    }

    .white-bubble {
        width: 24px;
        height: 24px;
        background-color: $white;
        border-radius: 100px;
        color: $blue;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .title-error {
        font-size: 22px;
        font-weight: bold;
        line-height: 1.27;
        letter-spacing: -0.2px;
        color: $white;
        margin-top: 24px;
    }

    .text-error {
        font-size: 17px;
        line-height: 1.41;
        color: $white;
        margin-top: 8px;
    }

    .btn-error-mlp {
        margin-top: 40px;
        width: 243px;
        position: fixed;
        bottom: 32px;
        @media screen and (min-width: $above-tablet-length) {
            position: static;
        }
    }

</style>
